// extracted by mini-css-extract-plugin
module.exports = {"root":"InviteHeaderSection_root__63wu3","container":"InviteHeaderSection_container__Od_p1","headerImage":"InviteHeaderSection_headerImage__XvJHY"};